import * as React from "react";

import {values} from "@Common/utils/objects";

export const ComponentsRows = ({components}) => (
    ComponentDetails(components).map((_) => ({
        columns: [
            {
                render: () => _.thumbnails,
            },
            {
                render: () => _.label,
            },
            {
                render: () => _.quantity,
            },
        ],
    }))
);

const ComponentDetails = (components) => (
    values(components).map((value) => ({
        thumbnails: (
            value?.proofUrls || value?.itemThumbnails || value.thumbnail ? (
                <img
                    src={
                        value.proofUrls?.jpg?.[0]?.path ??
                        value.itemThumbnails?.[0] ??
                        value.thumbnail
                    }
                    alt="thumbnail"
                />
            ) : (
                <img src={require("../../../../../../../public/assets/NoImageAvailable.png")} alt="No Image Available"/>
            )
        ),
        label: value.itemName,
        quantity: value.selections.quantity,
    }))
);
